import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './contract-signature.reducer';

export const ContractSignatureDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const contractSignatureEntity = useAppSelector(state => state.contractSignature.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="contractSignatureDetailsHeading">
          <Translate contentKey="crawlerBackendApp.contractSignature.detail.title">ContractSignature</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{contractSignatureEntity.id}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="crawlerBackendApp.contractSignature.status">Status</Translate>
            </span>
          </dt>
          <dd>{contractSignatureEntity.status}</dd>
          <dt>
            <span id="signerName">
              <Translate contentKey="crawlerBackendApp.contractSignature.signerName">Signer Name</Translate>
            </span>
          </dt>
          <dd>{contractSignatureEntity.signerName}</dd>
          <dt>
            <span id="signerEmail">
              <Translate contentKey="crawlerBackendApp.contractSignature.signerEmail">Signer Email</Translate>
            </span>
          </dt>
          <dd>{contractSignatureEntity.signerEmail}</dd>
          <dt>
            <span id="ipAddress">
              <Translate contentKey="crawlerBackendApp.contractSignature.ipAddress">Ip Address</Translate>
            </span>
          </dt>
          <dd>{contractSignatureEntity.ipAddress}</dd>
          <dt>
            <span id="signatureValue">
              <Translate contentKey="crawlerBackendApp.contractSignature.signatureValue">Signature Value</Translate>
            </span>
          </dt>
          <dd>{contractSignatureEntity.signatureValue}</dd>
          <dt>
            <span id="signedTimestamp">
              <Translate contentKey="crawlerBackendApp.contractSignature.signedTimestamp">Signed Timestamp</Translate>
            </span>
          </dt>
          <dd>
            {contractSignatureEntity.signedTimestamp ? (
              <TextFormat value={contractSignatureEntity.signedTimestamp} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="createdTimestamp">
              <Translate contentKey="crawlerBackendApp.contractSignature.createdTimestamp">Created Timestamp</Translate>
            </span>
          </dt>
          <dd>
            {contractSignatureEntity.createdTimestamp ? (
              <TextFormat value={contractSignatureEntity.createdTimestamp} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="rejectionReason">
              <Translate contentKey="crawlerBackendApp.contractSignature.rejectionReason">Rejection Reason</Translate>
            </span>
          </dt>
          <dd>{contractSignatureEntity.rejectionReason}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.contractSignature.signingSession">Signing Session</Translate>
          </dt>
          <dd>{contractSignatureEntity.signingSession ? contractSignatureEntity.signingSession.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/contract-signature" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/contract-signature/${contractSignatureEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ContractSignatureDetail;
